"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComboSavingsSubsidy = getComboSavingsSubsidy;
const LOW_SAVINGS_PERCENTAGE = 15;
const HIGH_SAVINGS_PERCENTAGE = 40;
const SAVINGS_RANGE_SIZE = HIGH_SAVINGS_PERCENTAGE - LOW_SAVINGS_PERCENTAGE;
const MAX_SUBSIDY_ADJUSTMENT = 15;
// Similar personal combos have a much better price for drivers as the acceptance rate is low for personal combos
const PERSONAL_COMBO_SAVINGS_MULTIPLIER = 0.5;
function getComboSavingsSubsidy({ isPersonal, savingsPercentage, savings, }) {
    // Limit the range of the savings percentage between 15 and 40%
    const cappedSavingsPercentage = Math.min(savingsPercentage, HIGH_SAVINGS_PERCENTAGE);
    const adjustedSavingsPercentage = Math.max(cappedSavingsPercentage, LOW_SAVINGS_PERCENTAGE);
    const savingsRangePlacement = (adjustedSavingsPercentage - LOW_SAVINGS_PERCENTAGE) / SAVINGS_RANGE_SIZE;
    // Set the savings split between 55% and 70% increasing the Daytrip fee for best combos
    let daytripFeeInPercent = 55 + savingsRangePlacement * MAX_SUBSIDY_ADJUSTMENT;
    // For personal combos profitability for drivers is increased by percentage of combo savings
    if (isPersonal) {
        daytripFeeInPercent = daytripFeeInPercent * PERSONAL_COMBO_SAVINGS_MULTIPLIER;
    }
    const negativeSubsidy = Math.round(savings * (daytripFeeInPercent / 100)) * -1;
    return negativeSubsidy;
}
//# sourceMappingURL=getComboSavingsSubsidy.js.map